"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxelarGeneralMessageReceivedEvent = exports.ModuleAxelarCallContractEvent = exports.AxelarCallContractEvent = exports.ExpiredPendingActionEvent = exports.UpdatePendingActionEvent = exports.NewPendingActionEvent = exports.BridgeReceivedEvent = exports.BridgeRevertedEvent = exports.BridgeAcknowledgedEvent = exports.BridgeSentEvent = exports.ExecutionOnCarbonErrorEvent = exports.WithdrawTokenConfirmedEvent = exports.WithdrawDeductedEvent = exports.DepositTokenEvent = exports.ExecuteFromCarbonEvent = exports.DeregisterTokenEvent = exports.RegisterNativeTokenEvent = exports.RegisterExternalTokenEvent = exports.NewExternalTokenMappingEvent = exports.RemoveConnectionEvent = exports.UpdateConnectionEvent = exports.NewConnectionEvent = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const bridge_1 = require("./bridge");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
exports.protobufPackage = "Switcheo.carbon.bridge";
const baseNewConnectionEvent = {};
exports.NewConnectionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connection !== undefined) {
            bridge_1.Connection.encode(message.connection, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewConnectionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connection = bridge_1.Connection.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewConnectionEvent);
        message.connection =
            object.connection !== undefined && object.connection !== null
                ? bridge_1.Connection.fromJSON(object.connection)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connection !== undefined &&
            (obj.connection = message.connection
                ? bridge_1.Connection.toJSON(message.connection)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseNewConnectionEvent);
        message.connection =
            object.connection !== undefined && object.connection !== null
                ? bridge_1.Connection.fromPartial(object.connection)
                : undefined;
        return message;
    },
};
const baseUpdateConnectionEvent = {
    connectionId: "",
    chainDisplayName: "",
    isEnabled: false,
};
exports.UpdateConnectionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.chainDisplayName !== "") {
            writer.uint32(18).string(message.chainDisplayName);
        }
        if (message.isEnabled === true) {
            writer.uint32(24).bool(message.isEnabled);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateConnectionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.chainDisplayName = reader.string();
                    break;
                case 3:
                    message.isEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateConnectionEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.chainDisplayName =
            object.chainDisplayName !== undefined && object.chainDisplayName !== null
                ? String(object.chainDisplayName)
                : "";
        message.isEnabled =
            object.isEnabled !== undefined && object.isEnabled !== null
                ? Boolean(object.isEnabled)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.chainDisplayName !== undefined &&
            (obj.chainDisplayName = message.chainDisplayName);
        message.isEnabled !== undefined && (obj.isEnabled = message.isEnabled);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseUpdateConnectionEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.chainDisplayName = (_b = object.chainDisplayName) !== null && _b !== void 0 ? _b : "";
        message.isEnabled = (_c = object.isEnabled) !== null && _c !== void 0 ? _c : false;
        return message;
    },
};
const baseRemoveConnectionEvent = { connectionId: "" };
exports.RemoveConnectionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRemoveConnectionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRemoveConnectionEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRemoveConnectionEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseNewExternalTokenMappingEvent = {};
exports.NewExternalTokenMappingEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.externalTokenMapping !== undefined) {
            bridge_1.ExternalTokenMapping.encode(message.externalTokenMapping, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewExternalTokenMappingEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.externalTokenMapping = bridge_1.ExternalTokenMapping.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewExternalTokenMappingEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromJSON(object.externalTokenMapping)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.externalTokenMapping !== undefined &&
            (obj.externalTokenMapping = message.externalTokenMapping
                ? bridge_1.ExternalTokenMapping.toJSON(message.externalTokenMapping)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseNewExternalTokenMappingEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromPartial(object.externalTokenMapping)
                : undefined;
        return message;
    },
};
const baseRegisterExternalTokenEvent = { carbonTokenName: "" };
exports.RegisterExternalTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.externalTokenMapping !== undefined) {
            bridge_1.ExternalTokenMapping.encode(message.externalTokenMapping, writer.uint32(10).fork()).ldelim();
        }
        if (message.carbonTokenName !== "") {
            writer.uint32(26).string(message.carbonTokenName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRegisterExternalTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.externalTokenMapping = bridge_1.ExternalTokenMapping.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.carbonTokenName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRegisterExternalTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromJSON(object.externalTokenMapping)
                : undefined;
        message.carbonTokenName =
            object.carbonTokenName !== undefined && object.carbonTokenName !== null
                ? String(object.carbonTokenName)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.externalTokenMapping !== undefined &&
            (obj.externalTokenMapping = message.externalTokenMapping
                ? bridge_1.ExternalTokenMapping.toJSON(message.externalTokenMapping)
                : undefined);
        message.carbonTokenName !== undefined &&
            (obj.carbonTokenName = message.carbonTokenName);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRegisterExternalTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromPartial(object.externalTokenMapping)
                : undefined;
        message.carbonTokenName = (_a = object.carbonTokenName) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRegisterNativeTokenEvent = {};
exports.RegisterNativeTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.externalTokenMapping !== undefined) {
            bridge_1.ExternalTokenMapping.encode(message.externalTokenMapping, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRegisterNativeTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.externalTokenMapping = bridge_1.ExternalTokenMapping.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRegisterNativeTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromJSON(object.externalTokenMapping)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.externalTokenMapping !== undefined &&
            (obj.externalTokenMapping = message.externalTokenMapping
                ? bridge_1.ExternalTokenMapping.toJSON(message.externalTokenMapping)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseRegisterNativeTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromPartial(object.externalTokenMapping)
                : undefined;
        return message;
    },
};
const baseDeregisterTokenEvent = {};
exports.DeregisterTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.externalTokenMapping !== undefined) {
            bridge_1.ExternalTokenMapping.encode(message.externalTokenMapping, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeregisterTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.externalTokenMapping = bridge_1.ExternalTokenMapping.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDeregisterTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromJSON(object.externalTokenMapping)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.externalTokenMapping !== undefined &&
            (obj.externalTokenMapping = message.externalTokenMapping
                ? bridge_1.ExternalTokenMapping.toJSON(message.externalTokenMapping)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseDeregisterTokenEvent);
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromPartial(object.externalTokenMapping)
                : undefined;
        return message;
    },
};
const baseExecuteFromCarbonEvent = {
    connectionId: "",
    sender: "",
    executableAddress: "",
};
exports.ExecuteFromCarbonEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        if (message.executableAddress !== "") {
            writer.uint32(26).string(message.executableAddress);
        }
        if (message.executionData.length !== 0) {
            writer.uint32(34).bytes(message.executionData);
        }
        if (message.token !== undefined) {
            coin_1.Coin.encode(message.token, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseExecuteFromCarbonEvent);
        message.executionData = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.executableAddress = reader.string();
                    break;
                case 4:
                    message.executionData = reader.bytes();
                    break;
                case 5:
                    message.token = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseExecuteFromCarbonEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.executableAddress =
            object.executableAddress !== undefined &&
                object.executableAddress !== null
                ? String(object.executableAddress)
                : "";
        message.executionData =
            object.executionData !== undefined && object.executionData !== null
                ? bytesFromBase64(object.executionData)
                : new Uint8Array();
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromJSON(object.token)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.sender !== undefined && (obj.sender = message.sender);
        message.executableAddress !== undefined &&
            (obj.executableAddress = message.executableAddress);
        message.executionData !== undefined &&
            (obj.executionData = base64FromBytes(message.executionData !== undefined
                ? message.executionData
                : new Uint8Array()));
        message.token !== undefined &&
            (obj.token = message.token ? coin_1.Coin.toJSON(message.token) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseExecuteFromCarbonEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.executableAddress = (_c = object.executableAddress) !== null && _c !== void 0 ? _c : "";
        message.executionData = (_d = object.executionData) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromPartial(object.token)
                : undefined;
        return message;
    },
};
const baseDepositTokenEvent = {
    connectionId: "",
    sender: "",
    receiver: "",
    assetAddress: "",
};
exports.DepositTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(26).string(message.receiver);
        }
        if (message.assetAddress !== "") {
            writer.uint32(34).string(message.assetAddress);
        }
        if (message.token !== undefined) {
            coin_1.Coin.encode(message.token, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDepositTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.receiver = reader.string();
                    break;
                case 4:
                    message.assetAddress = reader.string();
                    break;
                case 5:
                    message.token = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDepositTokenEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.assetAddress =
            object.assetAddress !== undefined && object.assetAddress !== null
                ? String(object.assetAddress)
                : "";
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromJSON(object.token)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.assetAddress !== undefined &&
            (obj.assetAddress = message.assetAddress);
        message.token !== undefined &&
            (obj.token = message.token ? coin_1.Coin.toJSON(message.token) : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseDepositTokenEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.receiver = (_c = object.receiver) !== null && _c !== void 0 ? _c : "";
        message.assetAddress = (_d = object.assetAddress) !== null && _d !== void 0 ? _d : "";
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromPartial(object.token)
                : undefined;
        return message;
    },
};
const baseWithdrawDeductedEvent = { sender: "", receiver: "" };
exports.WithdrawDeductedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.sender !== "") {
            writer.uint32(10).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.externalTokenMapping !== undefined) {
            bridge_1.ExternalTokenMapping.encode(message.externalTokenMapping, writer.uint32(26).fork()).ldelim();
        }
        if (message.token !== undefined) {
            coin_1.Coin.encode(message.token, writer.uint32(34).fork()).ldelim();
        }
        if (message.relayDetails !== undefined) {
            bridge_1.RelayDetails.encode(message.relayDetails, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseWithdrawDeductedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.externalTokenMapping = bridge_1.ExternalTokenMapping.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.token = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.relayDetails = bridge_1.RelayDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseWithdrawDeductedEvent);
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromJSON(object.externalTokenMapping)
                : undefined;
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromJSON(object.token)
                : undefined;
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromJSON(object.relayDetails)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.externalTokenMapping !== undefined &&
            (obj.externalTokenMapping = message.externalTokenMapping
                ? bridge_1.ExternalTokenMapping.toJSON(message.externalTokenMapping)
                : undefined);
        message.token !== undefined &&
            (obj.token = message.token ? coin_1.Coin.toJSON(message.token) : undefined);
        message.relayDetails !== undefined &&
            (obj.relayDetails = message.relayDetails
                ? bridge_1.RelayDetails.toJSON(message.relayDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseWithdrawDeductedEvent);
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.receiver = (_b = object.receiver) !== null && _b !== void 0 ? _b : "";
        message.externalTokenMapping =
            object.externalTokenMapping !== undefined &&
                object.externalTokenMapping !== null
                ? bridge_1.ExternalTokenMapping.fromPartial(object.externalTokenMapping)
                : undefined;
        message.token =
            object.token !== undefined && object.token !== null
                ? coin_1.Coin.fromPartial(object.token)
                : undefined;
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromPartial(object.relayDetails)
                : undefined;
        return message;
    },
};
const baseWithdrawTokenConfirmedEvent = {
    connectionId: "",
    sender: "",
    receiver: "",
    feeReceiverAddress: "",
    nonce: long_1.default.UZERO,
};
exports.WithdrawTokenConfirmedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.sender !== "") {
            writer.uint32(18).string(message.sender);
        }
        if (message.receiver !== "") {
            writer.uint32(26).string(message.receiver);
        }
        if (message.coin !== undefined) {
            coin_1.Coin.encode(message.coin, writer.uint32(34).fork()).ldelim();
        }
        if (message.feeReceiverAddress !== "") {
            writer.uint32(42).string(message.feeReceiverAddress);
        }
        if (message.relayFee !== undefined) {
            coin_1.Coin.encode(message.relayFee, writer.uint32(50).fork()).ldelim();
        }
        if (!message.nonce.isZero()) {
            writer.uint32(56).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseWithdrawTokenConfirmedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.receiver = reader.string();
                    break;
                case 4:
                    message.coin = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.feeReceiverAddress = reader.string();
                    break;
                case 6:
                    message.relayFee = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseWithdrawTokenConfirmedEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.sender =
            object.sender !== undefined && object.sender !== null
                ? String(object.sender)
                : "";
        message.receiver =
            object.receiver !== undefined && object.receiver !== null
                ? String(object.receiver)
                : "";
        message.coin =
            object.coin !== undefined && object.coin !== null
                ? coin_1.Coin.fromJSON(object.coin)
                : undefined;
        message.feeReceiverAddress =
            object.feeReceiverAddress !== undefined &&
                object.feeReceiverAddress !== null
                ? String(object.feeReceiverAddress)
                : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromJSON(object.relayFee)
                : undefined;
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.coin !== undefined &&
            (obj.coin = message.coin ? coin_1.Coin.toJSON(message.coin) : undefined);
        message.feeReceiverAddress !== undefined &&
            (obj.feeReceiverAddress = message.feeReceiverAddress);
        message.relayFee !== undefined &&
            (obj.relayFee = message.relayFee
                ? coin_1.Coin.toJSON(message.relayFee)
                : undefined);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = Object.assign({}, baseWithdrawTokenConfirmedEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.receiver = (_c = object.receiver) !== null && _c !== void 0 ? _c : "";
        message.coin =
            object.coin !== undefined && object.coin !== null
                ? coin_1.Coin.fromPartial(object.coin)
                : undefined;
        message.feeReceiverAddress = (_d = object.feeReceiverAddress) !== null && _d !== void 0 ? _d : "";
        message.relayFee =
            object.relayFee !== undefined && object.relayFee !== null
                ? coin_1.Coin.fromPartial(object.relayFee)
                : undefined;
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseExecutionOnCarbonErrorEvent = {
    nonce: long_1.default.UZERO,
    payloadType: "",
    dataEncoding: "",
};
exports.ExecutionOnCarbonErrorEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.payloadType !== "") {
            writer.uint32(18).string(message.payloadType);
        }
        if (message.dataEncoding !== "") {
            writer.uint32(26).string(message.dataEncoding);
        }
        if (message.data.length !== 0) {
            writer.uint32(34).bytes(message.data);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseExecutionOnCarbonErrorEvent);
        message.data = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.payloadType = reader.string();
                    break;
                case 3:
                    message.dataEncoding = reader.string();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseExecutionOnCarbonErrorEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.payloadType =
            object.payloadType !== undefined && object.payloadType !== null
                ? String(object.payloadType)
                : "";
        message.dataEncoding =
            object.dataEncoding !== undefined && object.dataEncoding !== null
                ? String(object.dataEncoding)
                : "";
        message.data =
            object.data !== undefined && object.data !== null
                ? bytesFromBase64(object.data)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.payloadType !== undefined &&
            (obj.payloadType = message.payloadType);
        message.dataEncoding !== undefined &&
            (obj.dataEncoding = message.dataEncoding);
        message.data !== undefined &&
            (obj.data = base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseExecutionOnCarbonErrorEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.payloadType = (_a = object.payloadType) !== null && _a !== void 0 ? _a : "";
        message.dataEncoding = (_b = object.dataEncoding) !== null && _b !== void 0 ? _b : "";
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    },
};
const baseBridgeSentEvent = {
    bridgeId: long_1.default.UZERO,
    chainId: "",
    gatewayAddress: "",
    nonce: long_1.default.UZERO,
};
exports.BridgeSentEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.gatewayAddress !== "") {
            writer.uint32(26).string(message.gatewayAddress);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(32).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBridgeSentEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.gatewayAddress = reader.string();
                    break;
                case 4:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBridgeSentEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.gatewayAddress =
            object.gatewayAddress !== undefined && object.gatewayAddress !== null
                ? String(object.gatewayAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.gatewayAddress !== undefined &&
            (obj.gatewayAddress = message.gatewayAddress);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseBridgeSentEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.gatewayAddress = (_b = object.gatewayAddress) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseBridgeAcknowledgedEvent = {
    bridgeId: long_1.default.UZERO,
    chainId: "",
    gatewayAddress: "",
    nonce: long_1.default.UZERO,
};
exports.BridgeAcknowledgedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.gatewayAddress !== "") {
            writer.uint32(26).string(message.gatewayAddress);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(32).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBridgeAcknowledgedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.gatewayAddress = reader.string();
                    break;
                case 4:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBridgeAcknowledgedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.gatewayAddress =
            object.gatewayAddress !== undefined && object.gatewayAddress !== null
                ? String(object.gatewayAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.gatewayAddress !== undefined &&
            (obj.gatewayAddress = message.gatewayAddress);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseBridgeAcknowledgedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.gatewayAddress = (_b = object.gatewayAddress) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseBridgeRevertedEvent = {
    bridgeId: long_1.default.UZERO,
    chainId: "",
    gatewayAddress: "",
    nonce: long_1.default.UZERO,
};
exports.BridgeRevertedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.gatewayAddress !== "") {
            writer.uint32(26).string(message.gatewayAddress);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(32).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBridgeRevertedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.gatewayAddress = reader.string();
                    break;
                case 4:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBridgeRevertedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.gatewayAddress =
            object.gatewayAddress !== undefined && object.gatewayAddress !== null
                ? String(object.gatewayAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.gatewayAddress !== undefined &&
            (obj.gatewayAddress = message.gatewayAddress);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseBridgeRevertedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.gatewayAddress = (_b = object.gatewayAddress) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseBridgeReceivedEvent = {
    bridgeId: long_1.default.UZERO,
    chainId: "",
    gatewayAddress: "",
    nonce: long_1.default.UZERO,
};
exports.BridgeReceivedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.gatewayAddress !== "") {
            writer.uint32(26).string(message.gatewayAddress);
        }
        if (!message.nonce.isZero()) {
            writer.uint32(32).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseBridgeReceivedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.gatewayAddress = reader.string();
                    break;
                case 4:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseBridgeReceivedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.gatewayAddress =
            object.gatewayAddress !== undefined && object.gatewayAddress !== null
                ? String(object.gatewayAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.gatewayAddress !== undefined &&
            (obj.gatewayAddress = message.gatewayAddress);
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseBridgeReceivedEvent);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.gatewayAddress = (_b = object.gatewayAddress) !== null && _b !== void 0 ? _b : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseNewPendingActionEvent = {
    nonce: long_1.default.UZERO,
    pendingActionType: long_1.default.UZERO,
    connectionId: "",
};
exports.NewPendingActionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (!message.pendingActionType.isZero()) {
            writer.uint32(16).uint64(message.pendingActionType);
        }
        if (message.connectionId !== "") {
            writer.uint32(26).string(message.connectionId);
        }
        if (message.relayDetails !== undefined) {
            bridge_1.RelayDetails.encode(message.relayDetails, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseNewPendingActionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.pendingActionType = reader.uint64();
                    break;
                case 3:
                    message.connectionId = reader.string();
                    break;
                case 4:
                    message.relayDetails = bridge_1.RelayDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseNewPendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromString(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromJSON(object.relayDetails)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.pendingActionType !== undefined &&
            (obj.pendingActionType = (message.pendingActionType || long_1.default.UZERO).toString());
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.relayDetails !== undefined &&
            (obj.relayDetails = message.relayDetails
                ? bridge_1.RelayDetails.toJSON(message.relayDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseNewPendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromValue(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromPartial(object.relayDetails)
                : undefined;
        return message;
    },
};
const baseUpdatePendingActionEvent = {
    nonce: long_1.default.UZERO,
    pendingActionType: long_1.default.UZERO,
    connectionId: "",
};
exports.UpdatePendingActionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (!message.pendingActionType.isZero()) {
            writer.uint32(16).uint64(message.pendingActionType);
        }
        if (message.connectionId !== "") {
            writer.uint32(26).string(message.connectionId);
        }
        if (message.relayDetails !== undefined) {
            bridge_1.RelayDetails.encode(message.relayDetails, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdatePendingActionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.pendingActionType = reader.uint64();
                    break;
                case 3:
                    message.connectionId = reader.string();
                    break;
                case 4:
                    message.relayDetails = bridge_1.RelayDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdatePendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromString(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromJSON(object.relayDetails)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.pendingActionType !== undefined &&
            (obj.pendingActionType = (message.pendingActionType || long_1.default.UZERO).toString());
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.relayDetails !== undefined &&
            (obj.relayDetails = message.relayDetails
                ? bridge_1.RelayDetails.toJSON(message.relayDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseUpdatePendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromValue(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromPartial(object.relayDetails)
                : undefined;
        return message;
    },
};
const baseExpiredPendingActionEvent = {
    nonce: long_1.default.UZERO,
    pendingActionType: long_1.default.UZERO,
    connectionId: "",
};
exports.ExpiredPendingActionEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (!message.pendingActionType.isZero()) {
            writer.uint32(16).uint64(message.pendingActionType);
        }
        if (message.connectionId !== "") {
            writer.uint32(26).string(message.connectionId);
        }
        if (message.relayDetails !== undefined) {
            bridge_1.RelayDetails.encode(message.relayDetails, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseExpiredPendingActionEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.pendingActionType = reader.uint64();
                    break;
                case 3:
                    message.connectionId = reader.string();
                    break;
                case 4:
                    message.relayDetails = bridge_1.RelayDetails.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseExpiredPendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromString(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromJSON(object.relayDetails)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.pendingActionType !== undefined &&
            (obj.pendingActionType = (message.pendingActionType || long_1.default.UZERO).toString());
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.relayDetails !== undefined &&
            (obj.relayDetails = message.relayDetails
                ? bridge_1.RelayDetails.toJSON(message.relayDetails)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseExpiredPendingActionEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.pendingActionType =
            object.pendingActionType !== undefined &&
                object.pendingActionType !== null
                ? long_1.default.fromValue(object.pendingActionType)
                : long_1.default.UZERO;
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.relayDetails =
            object.relayDetails !== undefined && object.relayDetails !== null
                ? bridge_1.RelayDetails.fromPartial(object.relayDetails)
                : undefined;
        return message;
    },
};
const baseAxelarCallContractEvent = {};
exports.AxelarCallContractEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.payload.length !== 0) {
            writer.uint32(10).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAxelarCallContractEvent);
        message.payload = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAxelarCallContractEvent);
        message.payload =
            object.payload !== undefined && object.payload !== null
                ? bytesFromBase64(object.payload)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseAxelarCallContractEvent);
        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
const baseModuleAxelarCallContractEvent = { nonce: long_1.default.UZERO };
exports.ModuleAxelarCallContractEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        if (message.payload.length !== 0) {
            writer.uint32(18).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseModuleAxelarCallContractEvent);
        message.payload = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                case 2:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseModuleAxelarCallContractEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        message.payload =
            object.payload !== undefined && object.payload !== null
                ? bytesFromBase64(object.payload)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseModuleAxelarCallContractEvent);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        message.payload = (_a = object.payload) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    },
};
const baseAxelarGeneralMessageReceivedEvent = { connectionId: "" };
exports.AxelarGeneralMessageReceivedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        if (message.payload.length !== 0) {
            writer.uint32(18).bytes(message.payload);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAxelarGeneralMessageReceivedEvent);
        message.payload = new Uint8Array();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.payload = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseAxelarGeneralMessageReceivedEvent);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        message.payload =
            object.payload !== undefined && object.payload !== null
                ? bytesFromBase64(object.payload)
                : new Uint8Array();
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        message.payload !== undefined &&
            (obj.payload = base64FromBytes(message.payload !== undefined ? message.payload : new Uint8Array()));
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseAxelarGeneralMessageReceivedEvent);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    },
};
var globalThis = (() => {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
const atob = globalThis.atob ||
    ((b64) => globalThis.Buffer.from(b64, "base64").toString("binary"));
function bytesFromBase64(b64) {
    const bin = atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
        arr[i] = bin.charCodeAt(i);
    }
    return arr;
}
const btoa = globalThis.btoa ||
    ((bin) => globalThis.Buffer.from(bin, "binary").toString("base64"));
function base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr) {
        bin.push(String.fromCharCode(byte));
    }
    return btoa(bin.join(""));
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
